export const ADD_AND_REMOVE_CATEGORIES_SEARCH = "ADD_AND_REMOVE_CATEGORIES_SEARCH";
export const ADD_AND_REMOVE_CATEGORIES_VIDEOS = "ADD_AND_REMOVE_CATEGORIES_VIDEOS";
export const ADD_AND_REMOVE_CATEGORIES_COMMUNITIES = "ADD_AND_REMOVE_CATEGORIES_COMMUNITIES";
export const ADD_AND_REMOVE_CATEGORIES_SHOP = "ADD_AND_REMOVE_CATEGORIES_SHOP";
export const ADD_AND_REMOVE_CATEGORIES_GAME = "ADD_AND_REMOVE_CATEGORIES_GAME";
